export default {
    brand: {
      "active" : true,
      "brandId" : "ad2afdc0-2e3d-9b4a-2f3d-b1ad0319866f",
      "brandName" : "NutriBullet",
      "brandSlug" : "nutribullet",
      "cartLink" : "https://www.nutriliving.com/cart",
      "cartName" : "Capital Brands",
      "cartPlatform" : "nutribullet",
      "cartSupport" : true,
      "category" : "consumer products and goods",
      "created_at" : "Wed Jul 12 2017 11:05:03 GMT-0400 (EDT)",
      "created_by" : "jordan@mikmak.tv",
      "modified_at" : "Tue Aug 22 2017 16:58:07 GMT-0400 (EDT)",
      "modified_by" : "maggie@mikmak.tv",
      "utmParameters" : ""
    },
    products: [
      {
        "cartMetadata" : {
          "addToCartUrl" : "https://www.nutriliving.com/cart/add/nl_nbp/1",
          "hiddenInputs" : []
        },
        "name" : "NutriBullet PRO",
        "price" : "99.99",
        "product-images" : [ "//cartassets.imgix.net/img/636/nl_nbp.jpg" ],
        "productUrl" : "https://www.nutriliving.com/shop/nutribullet-pro",
        "slug" : "nutribullet-pro"
      }
    ]
  }



// WEBPACK FOOTER //
// ./client/store/products/nutribulletpro.js